<app-organization-menu [id]="currentOrganizationId" *ngIf="menu === 'org'"></app-organization-menu>
<app-user-menu [orgId]="currentOrganizationId" *ngIf="menu === 'user'"></app-user-menu>
<app-vss-organization-menu [id]="currentOrganizationId" *ngIf="menu === 'vss'"></app-vss-organization-menu>
<div class="container pt-4" style="padding-bottom: 25px;">
    <h4 class="border-bottom pb-2 color-primary mb-3">{{'ORGANIZATION.PUSHNOTIFICATIONS.title' | translate}}
        <small class="form-text text-muted pl-2" style="font-size: 12px; display: block;">
            <ng-container *ngIf="menu === 'vss'; else elseTemplate">
                {{'ORGANIZATION.PUSHNOTIFICATIONS.vssTitleHelpText' | translate}}
            </ng-container>
            <ng-template #elseTemplate>
                {{'ORGANIZATION.PUSHNOTIFICATIONS.titleHelpText' | translate}}
            </ng-template>
        </small>
    </h4>
    <div class="row" *ngIf="this.errorMsg">
        <div class="col">
            <strong class="text-danger">{{'ORGANIZATION.PUSHNOTIFICATIONS.'+this.errorMsg | translate}}</strong>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <div class="form-group">
                <label>{{'GENERAL.german' | translate}}</label>
                <input type="text" class="form-control form-control-sm" maxlength="235" [(ngModel)]="message.de" />
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <div class="form-group">
                <label>{{'GENERAL.italian' | translate}}</label>
                <input type="text" class="form-control form-control-sm" maxlength="235" [(ngModel)]="message.it" />
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <div class="form-group">
                <label>{{'GENERAL.'+(menu === 'vss' ? 'ladin' : 'english') | translate}}</label>
                <input type="text" class="form-control form-control-sm" maxlength="235" [(ngModel)]="message.en" />
            </div>
        </div>
    </div>
    <div class="row mt-2" *ngIf="menu !== 'vss'">
        <div class="col-12 col-sm-6 text-center">
            <ng-container *ngIf="imagePath; else elseTemplate">
                <img [src]="imagePath" class="img-fluid img-thumbnail" style="height: 200px">
                <div class="text-center mt-1" *ngIf="imagePath">
                    <button type="button" class="btn btn-sm btn-outline-danger"
                        (click)="deleteImage()">{{'GENERAL.delete' | translate}}</button>
                </div>
            </ng-container>
            <ng-template #elseTemplate>
                <ng-container *ngIf="menu === 'vss'">
                    <img class="img-fluid img-thumbnail" style="height: 200px"
                    [src]="'assets/images/standard-picture-vss.png'" />
                </ng-container>
            </ng-template>
        </div>
        <div class="col-12 col-sm-6">
            <div class="custom-file mt-2">
                <label class="form-label">
                    {{'VSS.ORGANIZATION.INFORMATIONS.browse' | translate}}
                </label>
                <input class="form-control form-control-sm" type="file" id="customFile"
                    (change)="handleImageFileInput($event)">
                <small class="help-text text-danger" *ngIf="fileSizeError">
                    {{'VSS.ORGANIZATION.INFORMATIONS.fileSizeError' | translate}}
                </small>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col text-end">
            <button type="button" class="btn btn-sm btn-outline-primary" (click)="onSubmitPushNotification()">
                {{'GENERAL.save' | translate}}
            </button>
        </div>
    </div>
</div>
<div class="container">
    <h4 class="border-bottom pb-2 color-primary mb-3">{{'ORGANIZATION.PUSHNOTIFICATIONS.historyTitle' | translate}}
    </h4>
    <div class="row row-cols-1 row-cols-md-3">
      @for (notification of pastNotifications; track $index) {
        <div class="col mb-4">
            <div class="card h-100">
                <div class="card-body">
                    <div class="row">
                        <div class="col">
                            <strong class="m-0">{{'ORGANIZATION.PUSHNOTIFICATIONS.messageInItalian' |
                                translate}}</strong>
                            <p class="card-text mb-1">{{notification.body['it']}}</p>
                            <strong class="m-0">{{'ORGANIZATION.PUSHNOTIFICATIONS.messageInGerman' |
                                translate}}</strong>
                            <p class="card-text mb-0">{{notification.body['de']}}</p>
                            <strong class="m-0">{{(menu === 'vss' ? 'VSS.ORGANIZATION' : 'ORGANIZATION')+'.PUSHNOTIFICATIONS.messageInEnglish' |
                                translate}}
                            </strong>
                            <p class="card-text mb-0">{{notification.body['en']}}</p>
                            <p class="card-text"><small class="text-muted">
                                    {{'ORGANIZATION.PUSHNOTIFICATIONS.sentDate' | translate}}: {{notification.sentAt}}
                                </small>
                            </p>
                        </div>
                        <div class="col" *ngIf="notification.image && menu !== 'vss'">
                            <img class="img-fluid img-thumbnail" [src]="imageBaseUrl + notification.image" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
      }
    </div>
</div>
<app-toast></app-toast>
